import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"

const name = "PropertyCard"

type PropertyCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
}

const PropertyCard: React.FC<PropertyCardProps> = ({ parent, job, jobDetails }) => (
    <Card sx={{ mb: 1 }}>
        <CardContent>
            {jobDetails?.organisation &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Business Name:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.organisation}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.property &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Property:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.property}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.street &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Street:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.street}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.locality &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Locality:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.locality}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.town &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Town:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.town}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.county &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >County:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.county}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.postcode &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Postcode:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.postcode}</span></Typography>
                    </Grid>
                </Grid>}
        </CardContent>
    </Card>
)

PropertyCard.displayName = name

export default React.memo(PropertyCard)

